import React, { useCallback } from 'react'
import { useTheme } from '@/context/ThemeContext'
import AdminSidebar from '@/features/admin/components/AdminSidebar'
import UserTable from '@/features/admin/components/UserTable'
import { useAdminUsers } from '@/features/admin/hooks/useAdminUsers'

const AdminUsersPage: React.FC = () => {
  const { currentTheme } = useTheme()
  const {
    data,
    loading,
    error,
    page,
    setPage,
    updateUser,
    resetPassword,
    addToWorkspace,
    updateMembershipRole,
  } = useAdminUsers(1, 20)

  const handleUpdateUser = useCallback(
    async (
      id: string,
      payload: Partial<{ name: string; email: string; platformRole: 'user' | 'super_admin'; isActive: boolean }>,
    ) => {
      await updateUser(id, payload)
    },
    [updateUser],
  )

  return (
    <div className="min-h-screen" style={{ backgroundColor: currentTheme.primary }}>
      <AdminSidebar />

      <main className="lg:pl-56 min-h-screen">
        <div className="px-4 pt-16 pb-8 sm:px-6 lg:px-8 lg:pt-8">
          <div className="mb-8">
            <h1 className="text-2xl font-bold" style={{ color: currentTheme.text }}>
              Users
            </h1>
            <p className="mt-1 text-sm" style={{ color: currentTheme.secondrytext }}>
              Manage platform users and roles
            </p>
          </div>

          {error && (
            <div
              className="mb-6 rounded-2xl px-5 py-4 text-sm"
              style={{
                backgroundColor: currentTheme.errorBackground,
                color: currentTheme.errorText,
                border: `1px solid ${currentTheme.border}`,
              }}
            >
              {error}
            </div>
          )}

          <UserTable
            users={data?.data ?? []}
            total={data?.total ?? 0}
            page={page}
            limit={20}
            loading={loading}
            onPageChange={setPage}
            onUpdateUser={handleUpdateUser}
            onResetPassword={resetPassword}
            onAddToWorkspace={addToWorkspace}
            onUpdateMembershipRole={updateMembershipRole}
          />
        </div>
      </main>
    </div>
  )
}

export default AdminUsersPage
